import {useMainStore} from "@/store";
import StorageManager from "@/services/storageManager";

const guest = async () => {
    const store = useMainStore();

    if (store.loggedIn) {
        return {name: 'dashboard'};
    }

    if (StorageManager.has('identifier')) {
        try {
            await store.connectRequest({identifier: StorageManager.get('identifier')});
            return {name: 'dashboard'};
        } catch (e) {
            // Server responded with 503 — maintenance mode
            if (e.response !== undefined && e.response.status === 503) {
                return {name: 'maintenance'};
            }

            // Server completely unreachable (network error) — show downtime screen
            if (e.response === undefined) {
                store.SET_MAINTENANCE({unreachable: true});
                return {name: 'maintenance'};
            }

            // Other failures (401, etc.) — allow guest access to continue.
        }
    }
};

export default guest;
